"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = require("react");

var _usePortal = _interopRequireDefault(require("../use-portal"));

var _useWarning = _interopRequireDefault(require("../use-warning"));

var _assertion = require("../utils/assertion");

const defaultOptions = {
  onError: () => _assertion.__DEV__ && (0, _useWarning.default)('Failed to copy.', 'use-clipboard')
};

const useClipboard = (options = defaultOptions) => {
  const el = (0, _usePortal.default)('clipboard');

  const copyText = (el, text) => {
    if (!el || !text) return;
    const selection = window.getSelection();
    if (!selection) return;
    el.style.whiteSpace = 'pre';
    el.textContent = text;
    const range = window.document.createRange();
    selection.removeAllRanges();
    range.selectNode(el);
    selection.addRange(range);

    try {
      window.document.execCommand('copy');
    } catch (e) {
      options.onError && options.onError();
    }

    selection.removeAllRanges();

    if (el) {
      el.textContent = '';
    }
  };

  const copy = (0, _react.useCallback)(text => {
    copyText(el, text);
  }, [el]);
  return {
    copy
  };
};

var _default = useClipboard;
exports.default = _default;
module.exports = exports.default;